import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, CheckCircle2 } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
import { CountdownTimer } from './CountdownTimer';
export function Pricing() {
  return <section id="compra" className="py-8 sm:py-12 bg-[#f8fafc]" data-id="element-118">
      <div className="container px-4 mx-auto max-w-2xl" data-id="element-119">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl shadow-2xl overflow-hidden border-2 border-[#0c3b42]" data-id="element-120">
          {/* Header */}
          <div className="bg-[#0c3b42] p-5 sm:p-6 text-center text-white" data-id="element-121">
            <h2 className="text-xl sm:text-2xl font-black mb-1.5" data-id="element-122">
              KIT Psicología en Deporte Adaptado
            </h2>
            <p className="text-[#7fd1c9] font-medium text-sm sm:text-base" data-id="element-123">
              Sistema clínico adaptado para psicólogos deportivos que trabajan
              con deportistas con discapacidad.
            </p>
          </div>

          {/* Content */}
          <div className="p-5 sm:p-8" data-id="element-124">
            <CountdownTimer data-id="element-125" />

            <div className="mb-5" data-id="element-126">
              <h3 className="font-bold text-slate-800 mb-2.5 text-base" data-id="element-127">
                Incluye:
              </h3>
              <ul className="space-y-2" data-id="element-128">
                <li className="flex items-start gap-2.5" data-id="element-129">
                  <CheckCircle2 className="w-5 h-5 text-[#16a34a] flex-shrink-0 mt-0.5" data-id="element-130" />
                  <span className="text-sm text-slate-700 font-bold" data-id="element-131">
                    Todo el KIT Psicología en Deporte Adaptado Sistema Clínico
                    Adaptado 8 Etapas™
                  </span>
                </li>
                <li className="flex items-start gap-2.5" data-id="element-132">
                  <CheckCircle2 className="w-5 h-5 text-[#16a34a] flex-shrink-0 mt-0.5" data-id="element-133" />
                  <span className="text-sm text-slate-700 font-medium" data-id="element-134">
                    Guía de psicoeducación para el deportista
                  </span>
                </li>
                <li className="flex items-start gap-2.5" data-id="element-135">
                  <CheckCircle2 className="w-5 h-5 text-[#16a34a] flex-shrink-0 mt-0.5" data-id="element-136" />
                  <span className="text-sm text-slate-700 font-medium" data-id="element-137">
                    Banco de técnicas de regulación emocional adaptadas
                  </span>
                </li>
              </ul>
            </div>

            {/* Price Box */}
            <div className="bg-slate-50 rounded-2xl p-4 text-center mb-5 border border-slate-200" data-id="element-138">
              <div className="text-slate-400 font-bold text-lg line-through mb-0.5" data-id="element-139">
                $49.990
              </div>
              <div className="text-4xl sm:text-5xl font-black text-[#0c3b42] mb-1.5" data-id="element-140">
                $19.990{' '}
                <span className="text-xl text-slate-500 font-bold" data-id="element-141">ARS</span>
              </div>
              <div className="inline-block bg-[#16a34a] text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-142">
                Pago único
              </div>
            </div>

            {/* CTA */}
            <div className="flex flex-col items-center" data-id="element-143">
              {/* This is the actual checkout link */}
              <CtaButton href="https://checkout.sectordigital.online/cart/44211433865259:1" className="w-full text-base sm:text-lg py-4 mb-4" data-id="element-144">
                SÍ, QUIERO EL KIT AHORA
              </CtaButton>

              {/* Trust Badges */}
              <div className="flex flex-wrap justify-center gap-x-5 gap-y-1.5 text-xs sm:text-sm font-medium text-slate-600" data-id="element-145">
                <div className="flex items-center gap-1.5" data-id="element-146">
                  <ShieldCheck className="w-4 h-4 text-[#16a34a]" data-id="element-147" />
                  Pago único
                </div>
                <div className="flex items-center gap-1.5" data-id="element-148">
                  <ShieldCheck className="w-4 h-4 text-[#16a34a]" data-id="element-149" />
                  Acceso inmediato
                </div>
                <div className="flex items-center gap-1.5" data-id="element-150">
                  <ShieldCheck className="w-4 h-4 text-[#16a34a]" data-id="element-151" />
                  Garantía 7 días
                </div>
                <div className="flex items-center gap-1.5 w-full justify-center mt-1" data-id="element-152">
                  <ShieldCheck className="w-4 h-4 text-[#16a34a]" data-id="element-153" />
                  Material profesional descargable
                </div>
                <div className="flex items-center gap-1.5 w-full justify-center" data-id="element-154">
                  <ShieldCheck className="w-4 h-4 text-[#16a34a]" data-id="element-155" />
                  Listo para aplicar en sesión
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}